import { Injectable } from '@angular/core';

import { filter, map, Observable } from 'rxjs';

import { ConfigRoutes } from '@ripeurs/common/types/gateway/common/routes/config';

import { ApiV2Service } from '~app/services/api-v2.service';
import { UserService } from '~app/services/user.service';

import type { ConfigType } from '@ripeurs/common/types/service/storage/config';


type TrucksValueType = ConfigType.Trucks['value']['TRUCKS'];


@Injectable()
export class UtilityTrucksHandler {
	constructor(
		private readonly _api: ApiV2Service,
		private readonly _user: UserService,
	) {}

	public getTrucks(): Observable<TrucksValueType[]> {
		return this._api.request<ConfigRoutes.GetConfig.TrucksDef>(
			ConfigRoutes.GetConfig.config,
			{
				params: { type: 'trucks' },
				query: {
					keys: ['TRUCKS'],
					variant: 'trucks',
					regionIds: [this._user.loggedGetRegion().id],
					countryCode: this._user.loggedGetRegion().config.country
				},
			},
		).pipe(
			filter(({ code }: { code: 'FOUND' | 'NOT_FOUND', data: { config: TrucksValueType[] } }) => code === 'FOUND'),
			map(({ data }: { data: { config: TrucksValueType[] } }) => {
				const trucks: TrucksValueType[] = data.config ?? [];
				return trucks.sort((a, b) => {
					const numA = parseInt(a.NAME_LONG.split(' ')[1], 10);
					const numB = parseInt(b.NAME_LONG.split(' ')[1], 10);

					return numA - numB;
				});
			})
		);
	}
}
